import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rapport-visite',
  templateUrl: './rapport-visite.component.html',
  styleUrls: ['./rapport-visite.component.scss'],
})
export class RapportVisiteComponent implements OnInit {
  constructor() {}
  date_Debut: Date;
  ngOnInit(): void {}
}
